import React from "react";
import logo from "../assets/logo.png";

export default function Footer() {
  return (
    <footer className="footer pt-4 pb-4">
      <div className="container text-center">

        <img src={logo} alt="Border City Software Logo" className="footer-logo mb-3" />

        <p className="fw-bold m-0">Border City Software</p>
        <p className="text-muted small mb-3">
          Websites  Mobile Apps  AI Integration
        </p>

        <div className="d-flex justify-content-center gap-3">
          <a href="#" className="text-muted text-decoration-none">Home</a>
          <a href="/#services" className="text-muted text-decoration-none">Services</a>
          <a href="/#contact" className="text-muted text-decoration-none">Contact</a>
        </div>

        {/* New row for policy links */}
        <div className="text-center mt-2 small text-muted">
          <a href="/privacy" className="text-muted text-decoration-none">Privacy</a>
          {"  |  "}
          <a href="/agreement" className="text-muted text-decoration-none">User Agreement</a>
        </div>

        <p className="text-muted small mt-3 mb-0">
          © {new Date().getFullYear()} Border City Software
        </p>

      </div>
    </footer>
  );
}
